import team from '../../assets/team_work.svg'
import why from "../../assets/why.svg"
import fast from "../../assets/fast.svg"
import customer_support from "../../assets/customer_support.svg"
import we_design from "../../assets/we_design.svg"

export const sectionsData = [
    {
        "title": "Certified Team of Developers & Engineers",
        "desc": "Our Certified Team of Engineers and Management are always ready to work hand-in-hand as always to make sure your job gets delivered in due time from planning to prototyping, design, coding and finally deployment!",
        "button": "Meet the Team",
        "image": team
    },
    {
        "id": "#whyOwnASite",
        "title": "WHY EMBRACE TECHNOLOGY SOLUTIONS?",
        "desc": "In the digital age, technology is the driving force behind business growth and efficiency. Whether it's automation, software development, taxation, or data science, integrating innovative solutions can elevate your operations and competitiveness. Over 80% of businesses leveraging advanced technologies report significant improvements in productivity and profitability. Embrace technology to unlock your full potential and stay ahead in today's fast-paced market.",
        "button": "Learn How",
        "image": why
    },
    {
        "title": "Timely delivery",
        "desc": "Asides focusing on building efficient, user-friendly apps we are pretty mindful of time. Get your projects at the stipulated time!",
        "button": "see reviews",
        "image": fast
    },
    {
        "title": "24/7 CUSTOMER SUPPORT",
        "desc": "With our automated customer support system and fine-tuned customer care representatives, we are here to always serve you on time.",
        "image": customer_support,
        "button": "contact us"
    },
    {
        "title": "we design just what's best for you!",
        "desc": "Portfolio Website, Business Info Website, eCommerce Website? Real Estate? School Management? You make the choice, we bring it to life at its best!",
        "image": we_design
    },
]